import React, { Component } from 'react';
import {
  Route,
  Link,
} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import _ from 'lodash';

import * as history from '../common/history.js';
import * as DataAPI from "../common/DataAPI.js";
// import LandscapeAllTickets from './LandscapeAllTickets';
// import LandscapeWithBooking from './LandscapeWithBooking';
// import PortraitWithBooking from './PortraitWithBooking';
// import LandscapeBlock from './LandscapeBlock';
// import Landscape from './Landscape';
// import Portrait from './Portrait';
// import Kiosk768x1024 from './Kiosk-768x1024';
// import Kiosk800x1280 from './Kiosk-800x1280';
// import Kiosk1024x768 from './Kiosk-1024x768';
// import Kiosk800x1208 from './Kiosk-800x1208';
// import Kiosk1920x1280 from './Kiosk-1920x1280';
import KioskDisplay1920x1080 from './KioskDisplay-1920x1080';
// import CounterList from './CounterList';

const styles = {
  button: {
    height: 110,
    lineHeight: '110px',
    paddingLeft: 20,
    paddingRight: 20,
  },
  label: {
    fontSize: 60,
  },
  icon: {
    width: 90,
    height: 90
  },
};

class Display extends Component {
  constructor() {
    super();
    this.state = {
      displays: [],
    };
  }

  componentWillMount() {
    this.fetchDisplayList((err, displays) => {
      if (err) return console.error('fetchDisplayList error:', err);

      this.setState({
        displays,
      });
    });
  }

  fetchDisplayList(cb) {
    DataAPI.get('/api/display/list', {}, cb);
  }

  render() {
    return (
      <div>
        {
          history.getCurrentLocation() === '/display' &&
          <div className="display-list">
            {
              _.map(this.state.displays, (display, index) => (
                <Link to={`/display/${display.theme}/${display._id}`} key={index}>
                  <FlatButton
                    style={styles.button}
                    labelStyle={styles.label}
                    label={display.name}
                    fullWidth={true}
                  />
                </Link>
              ))
            }
          </div>
        }
        {/*<Route path="/display/landscape/:displayId" component={Landscape} />*/}
        {/*<Route path="/display/landscape-all-tickets/:displayId" component={LandscapeAllTickets} />*/}
        {/*<Route path="/display/landscape-with-booking/:displayId" component={LandscapeWithBooking} />*/}
        {/*<Route path="/display/portrait-with-booking/:displayId" component={PortraitWithBooking} />*/}
        {/*<Route path="/display/landscape-block/:displayId" component={LandscapeBlock} />*/}
        {/*<Route path="/display/portrait/:displayId" component={Portrait} />*/}
        {/*<Route path="/display/kiosk-768x1024/:displayId" component={Kiosk768x1024} />*/}
        {/*<Route path="/display/kiosk-800x1280/:displayId" component={Kiosk800x1280} />*/}
        {/*<Route path="/display/kiosk-1024x768/:displayId" component={Kiosk1024x768} />*/}
        {/*<Route path="/display/kiosk-800x1208/:displayId" component={Kiosk800x1208} />*/}
        {/*<Route path="/display/kiosk-1920x1280/:displayId" component={Kiosk1920x1280} />*/}
        <Route path="/display/kiosk-display-1920x1080/:displayId" component={KioskDisplay1920x1080} />

        {/*<Route path="/display/counter/:displayId" component={CounterList} />*/}
      </div>
    )
  }
}

export default Display;


// WEBPACK FOOTER //
// client/display/Display.js